import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useQuery } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import Spin from 'components/common/Spin';
import { GET_STUDENT } from 'graphql/lc/students';
import Timeline from 'modules/lc/timeline';
import Schools from 'modules/student/school';
import StudentProfile from '../../components/student-profile';
import Essays from 'modules/student/essays';
import StudentStats from 'components/student-stats';
import Team from '../admin/team';
import Subscription from './subscription';
import FinancialAid from './financial-aid';
import Chat from './chat';
import { GET_STUDENT_PROFILE } from 'graphql/parent/student';
import Fab from '@material-ui/core/Fab';
import ForumIcon from '@material-ui/icons/Forum';
import StudentChatHistory from 'modules/admin/student-chat-history';
import StudentTextHistory from 'modules/admin/student-text-history';
import CommonApp from '../student/common-app';
import Upsell from './upsell';
import StudentFiles from 'components/student-files'

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
    zIndex: 1000,
  },
}));

const StudentRoutes = ({ match }) => {
  const classes = useStyles();
  const [showChat, setShowChat] = useState(false);
  const { data, loading } = useQuery(GET_STUDENT, {
    fetchPolicy: 'network-only',
    variables: { user_id: Number(match.params.id) },
  });

  const { data: profileData } = useQuery(GET_STUDENT_PROFILE, {
    variables: { id: match.params.id },
  });

  if (loading || !profileData) return <Spin linear spinning />;

  const student = data.users[0];
  const profile = profileData?.student_profile[0];

  if (!student) return <div>Student not found</div>;
  if (!profile) return <Spin spinning linear />;

  student.sub = student.user_cognito_sub;
  student.id = student.user_id;
  student.email = student.user_email;
  student.fname = student.user_first_name;
  student.lname = student.user_last_name;
  student.name = student.fname + ' ' + student.lname;
  student.financial_aid_settings = profile.financial_aid_settings;
  student.curriculum_id = profile.curriculum_id;
  student.class_year = profile.graduation_year;

  const toggleChat = () => setShowChat(!showChat);

  return (
    <div>
      <Fab color="primary" className={classes.fab} onClick={toggleChat}>
        <ForumIcon />
      </Fab>
      <Switch>
        <Route
          path="/students/:id/profile"
          render={(props) => (
            <StudentProfile editable={false} {...props} student={student} />
          )}
        />
        <Route
          path="/students/:id/team"
          render={(props) => <Team {...props} student={student} />}
        />
        <Route
          path="/students/:id/financial-aid"
          render={(props) => (
            <FinancialAid
              {...props}
              student={student}
              guardians={profile.user.guardians}
            />
          )}
        />
        <Route
          path="/students/:id/timeline"
          render={(props) => (
            <Timeline
              readOnly
              disableScheduling
              disableView
              student={student}
              {...props}
            />
          )}
        />
        <Route
          path="/students/:id/conversations"
          render={(props) => (
            <StudentChatHistory {...props} student={student} />
          )}
        />
        <Route
          path="/students/:id/conversations-text"
          render={(props) => (
            <StudentTextHistory {...props} student={student} />
          )}
        />
        <Route
          path="/students/:id/common-app"
          render={(props) => (
            <CommonApp readOnly {...props} student={student} />
          )}
        />
        <Route
          path="/students/:id/essays"
          render={(props) => <Essays readOnly {...props} student={student} />}
        />
        <Route
          path="/students/:id/schools"
          render={(props) => (
            <Schools
              readOnly
              {...props}
              student={{
                ...student,
                highschool_info: profile.highschool_info,
              }}
            />
          )}
        />
        <Route
          path="/students/:id/stats"
          render={(props) => <StudentStats {...props} student={student} />}
        />
        <Route
          path="/students/:id/subscription"
          render={(props) => <Subscription {...props} student={student} />}
        />
        <Route
          path="/students/:id/upsell"
          render={(props) => <Upsell {...props} student={student} />}
        />
      </Switch>
      <Chat
        student={student}
        rooms={student.chat_rooms}
        toggle={toggleChat}
        show={showChat}
      />
    </div>
  );
};

export default StudentRoutes;
